import React  from 'react';
import clsx from 'clsx';

const FooterSide = () => (<>
  <div id={'footer'} className={clsx( 'view-footer','text-center', 'w-100', 'd-none')} style={{ backgroundColor: '#fff' }}>
  </div>
</>);

export default FooterSide;
